import API from 'services/API';

export default function checkInnAndPassword(inn) {
  return API.request({
    method: 'GET',
    url: `/checkInnAndPwdHashStatus?inn=${inn}`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
